import type { TheoryTest } from "../../../api/theoryTests/TheoryTest.typed";

const PASSING_FRACTION = 0.8;

export function theoryTestResultFraction(result: number): number {
  return result <= 1 ? result : result / 100;
}

// An offline QCM stays reachable when attempts already exist, so past results are never lost.
export function hasTheoryTestHistory(testResult?: string, theoryTests?: TheoryTest[]): boolean {
  return Boolean(testResult?.trim()) || (theoryTests?.length ?? 0) > 0;
}

// Legacy tests are stored as a percentage string on the training, newer ones as TheoryTests rows.
export function isTheoryTestValidated(testResult?: string, theoryTests?: TheoryTest[]): boolean {
  if (testResult && parseFloat(testResult) / 100 >= PASSING_FRACTION) return true;
  return theoryTests?.some((t) => theoryTestResultFraction(t.Result) >= PASSING_FRACTION) ?? false;
}
